export class CarregarCartaoRequest {
    public qrcode: string;
    public colaboradorID: number;
    public gestorGuid: string;
    public produtoGuid: string;
    public valor: number;
    public cedenteGuid: string;
    public Senha: string;
    public SenhaConfirmacao: string;
}
